import { MessageSquarePlus } from '@lucide/vue';
import type { CommandFactory } from './commands';
import { appLocationCommand } from './appCommand';

/**
 * The agent app's palette entry (I-2348): a new conversation — the agent's chat
 * view opens its „Neue Unterhaltung“ dialog for `?new=chat`. Opening the
 * shell's assistant is registered by the shell layout (shellAppCommands.ts).
 */
export const agentCommands: CommandFactory = ({ router, t, appLabel: agent }) => [
  appLocationCommand(router, {
    id: 'agent.newChat',
    app: 'agent',
    group: agent,
    label: `${agent}: ${t('chat.new_chat')}`,
    href: '/agent?new=chat',
    icon: MessageSquarePlus,
    keywords: ['agent', 'ki', 'ai', 'unterhaltung', 'chat', 'conversation', 'neu', 'new'],
  }),
];
